import { ApiFile } from './ApiFile';
import { Model, Nullable } from './Model';

export interface Answer extends Model {
  text?: Nullable<string>;
  mediaFile?: Nullable<ApiFile>;
  mediaLink?: Nullable<string>;
  altText?: Nullable<string>;
}

export interface PositionalAnswer extends Answer {
  validPositions: number[];
}
export interface OrderingItem extends PositionalAnswer {
  order: number;
  dndOrdenationColumn: number;
}
export interface PositionalItem extends PositionalAnswer {
  order: number;
  dndPositionalColumn: number;
}
export interface QuizAnswer extends Answer {
  isCorrect: boolean;
  answerVerifier?: string;
}

//eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FillInTheBlankOption extends PositionalAnswer {}

export enum QuizAnswerTypeEnum {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
}

// DTOs

export type AnswerCreateDTO = Omit<Answer, 'id' | 'mediaFile'> & {
  id?: number;
  mediaFile?: File | string | null;
};

export type QuizAnswerCreateDTO = AnswerCreateDTO &
  Pick<QuizAnswer, 'isCorrect'>;

export type OrderingItemCreateDTO = AnswerCreateDTO &
  Pick<OrderingItem, 'validPositions'>;

export type QuestionCreateDTO = AnswerCreateDTO;

export type PositionalAnswerCreateDTO = AnswerCreateDTO &
  Pick<PositionalItem, 'validPositions'>;

export type FillInTheBlankOptionCreateDTO = AnswerCreateDTO &
  Pick<FillInTheBlankOption, 'validPositions'>;
